import { NarrativeTemplate } from './templates'

export const maintenanceTemplates: NarrativeTemplate[] = [
  // Critical maintenance needed
  {
    id: 'maintenance-critical',
    category: 'maintenance',
    condition: (data) => Number(data.criticalCount) > 0,
    priority: 100,
    template: `MAINTENANCE OPTIMIZATION REPORT

Critical Actions Required: {criticalCount}
Total Recommendations: {recommendationCount}

Cost-Benefit Analysis:
• Proactive maintenance cost: {totalCostFormatted}
• Prevented downtime value: {totalSavingsFormatted}
• Net benefit: {netBenefit}
• ROI: {roiMultiplier}x return on investment

{criticalCount} critical maintenance action(s) should be completed within 24 hours to prevent potential failures and maximize cost savings.

Delaying critical maintenance increases the risk of unplanned downtime, which typically costs 3-5x more than preventive intervention.`
  },

  // Positive ROI scenario
  {
    id: 'maintenance-positive-roi',
    category: 'maintenance',
    condition: (data) => Number(data.roiMultiplier) > 2,
    priority: 80,
    template: `Maintenance Optimization Opportunity

{recommendationCount} maintenance actions identified with excellent ROI.

Financial Summary:
• Investment required: {totalCostFormatted}
• Estimated savings: {totalSavingsFormatted}
• Net benefit: {netBenefit}
• ROI: {roiMultiplier}x

This represents a strong business case for proactive maintenance. Every dollar invested in these recommendations is expected to return {roiMultiplier} dollars in prevented downtime and repairs.

Recommendation: Prioritize these maintenance actions in the upcoming maintenance window.`
  },

  // Moderate recommendations
  {
    id: 'maintenance-moderate',
    category: 'maintenance',
    condition: (data) => Number(data.recommendationCount) > 0,
    priority: 60,
    template: `Maintenance Schedule Recommendations

{recommendationCount} actions recommended for optimal asset performance.

Cost Analysis:
• Total investment: {totalCostFormatted}
• Expected savings: {totalSavingsFormatted}
• Net benefit: {netBenefit}
• ROI: {roiMultiplier}x

These preventive actions balance cost efficiency with risk reduction. Schedule high-priority items within the next maintenance window.`
  },

  // No recommendations
  {
    id: 'maintenance-none',
    category: 'maintenance',
    condition: (data) => Number(data.recommendationCount) === 0,
    priority: 50,
    template: `Maintenance Status: Optimal

No immediate maintenance actions required.

All assets are operating within normal parameters. Continue standard monitoring and scheduled maintenance routines.

Next recommended review: 7 days`
  },

  // Default
  {
    id: 'maintenance-default',
    category: 'maintenance',
    priority: 10,
    template: `Maintenance Summary

{recommendationCount} actions recommended
Investment: {totalCostFormatted}
Expected savings: {totalSavingsFormatted}
ROI: {roiMultiplier}x`
  }
]
